(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq-accordion"] && !Shopify.designMode) return;
  try {
    
  function initFaqAccordions() {
    document.querySelectorAll(".sc-faq__list").forEach(function(list) {
      if (list.dataset.faqInitialized) return;
      list.dataset.faqInitialized = "true";

      var allowMultiple = list.dataset.allowMultiple === "true";

      list.querySelectorAll(".sc-faq__item").forEach(function(item) {
        var summary = item.querySelector(".sc-faq__summary");
        if (!summary) return;

        summary.addEventListener("click", function(e) {
          e.preventDefault();

          if (item.open && !item.classList.contains("is-closing")) {
            item.classList.add("is-closing");
            item.setAttribute("aria-expanded", "false");
            setTimeout(function() {
              item.open = false;
              item.classList.remove("is-closing");
            }, 320);
          } else if (!item.open) {
            if (!allowMultiple) {
              list.querySelectorAll(".sc-faq__item[open]").forEach(function(sibling) {
                if (sibling !== item && !sibling.classList.contains("is-closing")) {
                  sibling.classList.add("is-closing");
                  sibling.setAttribute("aria-expanded", "false");
                  setTimeout(function() {
                    sibling.open = false;
                    sibling.classList.remove("is-closing");
                  }, 320);
                }
              });
            }

            item.open = true;
            item.setAttribute("aria-expanded", "true");
          }
        });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", initFaqAccordions);
  if (document.readyState === "interactive" || document.readyState === "complete") {
    initFaqAccordions();
  }
  document.addEventListener("shopify:section:load", initFaqAccordions);
  document.addEventListener("shopify:block:select", function(e) {
    var block = e.target;
    if (block && block.classList.contains("sc-faq__item")) {
      block.open = true;
      block.setAttribute("aria-expanded", "true");
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
